import application_settings from '../applicationSettings';
import Event from './Event';

class SaveAddress extends Event {
  eventName = "oms_saveAddress";

  constructor() {
    super();
    this.add();
  }

  /**
   * @override
   *
   * Event Function for Get loyalty points
   *
   * @return void
   *
   */
  eventFunction(data) {
    let thisObj = this;
    let requestId = data.request_id ? data.request_id : "";
    let action = data.action ? data.action : "";

    // request data
    data.endPoint = application_settings.endPoints.addAddress;
    data.method = 'POST';
    data.canUsePublicAuth = false;
    data.data = data.data ? data.data : {};

    // send request
    this.sendRequest(data, function (response) {
      if (response) {
        //format response data
        let data = thisObj.formatResponseData(response);

        //fire success event
        thisObj.onSuccessEvent(data, {
          action: action,
          request_id: requestId,
        });
      }
    });
    
  }
}

export default SaveAddress;